// extracted by mini-css-extract-plugin
export var active = "_gk-2";
export var recordingDot = "_gk-1";
export var recordingIndicator = "_gk-0";